import React, { useState, useEffect } from 'react';
import { icons } from '../../helpers/constants';

const Button = ({ btnClass, lightIcon, className, onClick, icon, notext, children }) => {
    useEffect(() => {
    
    },[])

    
    return(
        <>
            <button
                className={`d-flex align-items-center justify-content-center btn ${btnClass ? btnClass : "btn-secondary"} ${className ? className : ""}`} 
                onClick={onClick}
            >
                {icon && <img 
                    className={`${notext ? "size_15" : "button_icon me-1"} ${lightIcon || (btnClass === "btn-primary" && icon !== icons.mass_share) ? "icon_light" : "icon_dark"}`} 
                    src={icon} 
                    alt={"..."}
                />}     
                <label className={`cursor-pointer btn-text bold ${notext ? "d-none" : ""}`}>
                    {icon && '\u00A0'}
                    {children}
                </label>
            </button>
        </>
    )
}

export default Button;